/* Pausar la cinta fuera de pantalla sin cambiar su diseño, ritmo o posición.
   Un observador compartido; no mediciones ni escrituras por cada scroll. */
(function () {
  'use strict';
  if (window.__miMarqueeVisibilidad) return;
  window.__miMarqueeVisibilidad = true;
  var cintas = new Map();

  function actualizar(cinta, visible) {
    var pausada = document.hidden || !visible || !cinta.hasAttribute('data-mi-mq-lista');
    if (cinta.hasAttribute('data-mi-mq-pausada') !== pausada) {
      cinta.toggleAttribute('data-mi-mq-pausada', pausada);
    }
  }

  // Las copias comparten archivo y decodificación. Preparar cada recurso una
  // sola vez evita esperar decenas de decodificaciones redundantes.
  function esperarImagen(imagen) {
    return new Promise(function (resolver) {
      function lista() {
        imagen.removeEventListener('load', lista);
        imagen.removeEventListener('error', lista);
        if (imagen.naturalWidth && imagen.decode) {
          imagen.decode().catch(function () {}).then(resolver);
        } else {
          resolver();
        }
      }
      if (imagen.complete) { lista(); return; }
      imagen.addEventListener('load', lista, { once: true });
      imagen.addEventListener('error', lista, { once: true });
    });
  }
  var observador = window.IntersectionObserver ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (entrada) {
      if (!cintas.has(entrada.target)) return;
      cintas.set(entrada.target, entrada.isIntersecting);
      actualizar(entrada.target, entrada.isIntersecting);
    });
  }, { rootMargin: '200px 0px' }) : null;

  function registrar(cinta) {
    if (cintas.has(cinta)) return;
    var visible = !observador;
    cintas.set(cinta, visible);
    actualizar(cinta, visible);
    if (observador) observador.observe(cinta);
    var recursos = new Set();
    var logos = Array.from(cinta.querySelectorAll('img')).filter(function (imagen) {
      var clave = [imagen.currentSrc || imagen.src, imagen.srcset, imagen.sizes].join('|');
      if (recursos.has(clave)) return false;
      recursos.add(clave);
      return true;
    });
    Promise.all(logos.map(esperarImagen)).then(function () {
      // Una sección retirada por el editor no debe recibir escrituras tardías.
      if (!cintas.has(cinta)) return;
      cinta.setAttribute('data-mi-mq-lista', '');
      actualizar(cinta, cintas.get(cinta));
    });
  }
  function montar(raiz) {
    if (raiz.matches && raiz.matches('.mi-marquee')) registrar(raiz);
    raiz.querySelectorAll('.mi-marquee').forEach(registrar);
  }
  montar(document);
  document.addEventListener('visibilitychange', function () {
    cintas.forEach(function (visible, cinta) { actualizar(cinta, visible); });
  });
  document.addEventListener('shopify:section:load', function (evento) { montar(evento.target); });
  document.addEventListener('shopify:section:unload', function (evento) {
    cintas.forEach(function (visible, cinta) {
      if (!evento.target.contains(cinta)) return;
      if (observador) observador.unobserve(cinta);
      cintas.delete(cinta);
    });
  });
})();
